module.exports = __webpack_public_path__ + "static/media/logo.a0d4319a.svg";